import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/preferred-locations/new/loading';

export const Route = createFileRoute('/_private/settings/preferred-locations/new')({
  component: Loading,
});
